import gql from 'graphql-tag'

export const GET_POST_PRE_SIGNED_URL = gql`
  mutation GET_POST_PRE_SIGNED_URL($fileName: String!, $mimetype: String!) {
    createPresignedPostUrl(fileName: $fileName, mimetype: $mimetype)
  }
`
